import FinalBookShopTable from '../components/final_book_shop_table.vue'

export default {
  components: {
    FinalBookShopTable
  },
  data: () => ({
    message: 'A'
  })
}